import { get, sortBy, deburr } from 'lodash'

export default function(data = []) {
  const result = {}

  for (const item of data) {
    const category = get(item, 'activitySection.value')

    if (category) {
      // If category doesn't exist create empty arrays
      if (!result[category]) {
        result[category] = { categories: [], subCategories: {} }
      }

      // if parent isn't set then its category do add it
      if (!item.parent) {
        result[category].categories.push(item)

        // Create object in subCategory if doesn't exist
        if (!result[category].subCategories[item.id.toString()]) {
          result[category].subCategories[item.id.toString()] = []
        }

        // If subcategory object exists, then add item
      } else if (result[category].subCategories[item.parent.id.toString()]) {
        result[category].subCategories[item.parent.id.toString()].push(item)

        // Create subCategory object for parent
      } else {
        result[category].subCategories[item.parent.id.toString()] = [item]
      }
    }
  }

  const keys = Object.keys(result)

  // sort activities because of mutations above
  keys.forEach(key => {
    const subCategoriesKeys = Object.keys(result[key].subCategories) || []
    const subCategoriesSorted = []

    subCategoriesKeys.forEach(subCatKey => {
      subCategoriesSorted[subCatKey] = sortBy(
        result[key].subCategories[subCatKey],
        [item => deburr(item.translatedName)]
      )
    })

    result[key] = {
      categories: sortBy(result[key].categories, [
        item => deburr(item.translatedName)
      ]),
      subCategories: subCategoriesSorted
    }
  })

  return result
}
